import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import phoneImg from "../assets/sphone.jpeg";
import computerImg from "../assets/nl.jpg";
import acImg from "../assets/download.jpeg";
import speakerImg from "../assets/speakers.jpg";
import accessoriesImg from "../assets/acc.jpg";
import tvImg from "../assets/tele.jpeg";
import blenderImg from "../assets/blender.jpg";
import fanImg from "../assets/ifan.jpg";
import fridgeImg from "../assets/fridge.jpg";
import comboImg from "../assets/combo.jpg";

const categories = [
  { id: 2, image: phoneImg, label: "Phones", path: "/phones" },
  { id: 3, image: computerImg, label: "Laptops", path: "/computers" },
  { id: 4, image: acImg, label: "Air-Conditioners", path: "/air-condition" },
  { id: 5, image: speakerImg, label: "Audio Systems", path: "/speakers" },
  { id: 6, image: accessoriesImg, label: "Accessories", path: "/accessories" },
  { id: 7, image: tvImg, label: "Television", path: "/television" },
  { id: 8, image: fridgeImg, label: "Fridge", path: "/refrigerator" },
  { id: 9, image: blenderImg, label: "Appliances", path: "/appliances" },
  { id: 10, image: fanImg, label: "Fan", path: "/fan" },
  { id: 1, image: comboImg, label: "Combo", path: "/combo" },
];

const CategoryComponent = () => {
  const navigate = useNavigate();
  const [showArrows, setShowArrows] = useState(false);
  const containerRef = React.useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const updateArrowVisibility = () => {
      if (container) {
        setShowArrows(container.scrollWidth > container.clientWidth);
      }
    };

    updateArrowVisibility();
    window.addEventListener("resize", updateArrowVisibility);
    return () => window.removeEventListener("resize", updateArrowVisibility);
  }, []);

  const scrollLeft = () => {
    containerRef.current?.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    containerRef.current?.scrollBy({ left: 200, behavior: "smooth" });
  };

  return (
    <div className="container mx-auto px-1">
      <div className="bg-gradient-to-r from-green-600 to-green-400 p-1 rounded-lg shadow-xl mt-2">
        <h5 className="text-white text-sm font-semibold">Shop by Category</h5>
        <div className="relative mt-1">
          {showArrows && (
            <>
              <Button
                icon={<LeftOutlined />}
                shape="circle"
                className="absolute top-1/2 -translate-y-1/2 left-2 z-10 bg-white text-gray-800 shadow-md hover:bg-gray-200 transition-all duration-300 hidden sm:block"
                onClick={scrollLeft}
              />
              <Button
                icon={<RightOutlined />}
                shape="circle"
                className="absolute top-1/2 -translate-y-1/2 right-2 z-10 bg-white text-gray-800 shadow-md hover:bg-gray-200 transition-all duration-300 hidden sm:block"
                onClick={scrollRight}
              />
            </>
          )}
          <div
            ref={containerRef}
            className="flex gap-4 overflow-x-auto no-scrollbar scrollbar-hide px-2 py-2"
          >
            {categories.map((category) => (
              <div
                key={category.id}
                onClick={() => navigate(category.path)}
                className="relative min-w-[120px] w-[140px] h-[120px] sm:w-[160px] sm:h-[140px] md:w-[180px] md:h-[160px] flex items-center justify-center cursor-pointer bg-white p-2 rounded-lg shadow-md hover:shadow-xl transition-transform transform hover:scale-105"
              >
                <img
                  src={category.image}
                  alt={category.label}
                  className="w-full h-full object-cover rounded-lg"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-center text-sm py-1 rounded-b-lg">
                  {category.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryComponent;
